import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router";
import { Grid, Paper, TextField, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { CircularProgress } from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Controls from "../components/InputControls/Controls";
import * as Yup from "yup";

const { REACT_APP_SERVER_URL } = process.env;

const UserInfo = () => {
  const validationSchema = Yup.object().shape({
    secondaryEmail: Yup.string()
      .required("Email is required")
      .email("Email is invalid"),
  });

  // Reac the parameters : id
  let { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [candidate, setCandidate] = useState();

  const ariaLabel = { "aria-label": "description" };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(validationSchema) });

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const { data: response } = await axios.get(
          `${REACT_APP_SERVER_URL}/candidates/${id}`
        );
        setCandidate(response);
      } catch (error) {
        console.error(error.message);
        setLoading(false);
      }
      setLoading(false);
    };
    fetchData();
  }, [id]);

  return (
    <>
      {loading ? (
        <Box sx={{ display: "flex" }}>
          <CircularProgress />
        </Box>
      ) : (
        <Paper
          elevation={3}
          style={{
            margin: "20px",
            padding: "40px",
            minHeight: "70vh",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid
            container
            spacing={2}
            justifyContent="center"
            alignItems="center"
          >
            <Grid item xs={12}>
              <Typography
                component="div"
                style={{ textAlign: "left", fontSize: "20px" }}
              >
                User Information
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography
                component="div"
                style={{ textAlign: "left", fontSize: "12px" }}
              >
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Praesent venenatis, nunc in mattis blandit, justo nunc dapibus
                purus, condimentum semper risus ipsum nec arcu. Curabitur ac
                commodo sem. Nullam tempus metus et nibh iaculis porttitor. Duis
                sed metus consectetur, congue lorem ac, tincidunt neque. Etiam
                mollis viverra ipsum in accumsan. Aenean tincidunt non risus ut
                rhoncus. Quisque eleifend, libero non lobortis posuere, justo
                enim luctus risus, et ornare augue leo in nulla
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Grid
                container
                spacing={2}
                justifyContent="center"
                alignItems="center"
              >
                <Grid item xs={12} md={6}>
                  <TextField
                    id="outlined-uncontrolled"
                    label="First Name"
                    variant="standard"
                    placeholder="Enter Your First Name"
                    margin="normal"
                    name="firstName"
                    required
                    value={candidate.firstname}
                    color="primary"
                    inputProps={ariaLabel}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    id="last-name"
                    label="Last Name"
                    variant="standard"
                    placeholder="Enter Your Last Name"
                    margin="normal"
                    name="lastName"
                    required
                    value={candidate.lastname}
                    fullWidth
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid
                container
                spacing={2}
                justifyContent="center"
                alignItems="center"
              >
                <Grid item xs={12} md={6}>
                  <TextField
                    id="email"
                    label="Primary E-mail"
                    variant="standard"
                    placeholder="Enter Your E-mail Address"
                    fullWidth
                    margin="normal"
                    name="emailAddress"
                    required
                    value={candidate.email}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    id="email"
                    label="Confirm E-mail"
                    variant="standard"
                    placeholder="Enter Your E-mail Address"
                    fullWidth
                    margin="normal"
                    name="emailAddress"
                    value={candidate.email}
                    required
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <form onSubmit={handleSubmit}>
                <Grid container>
                  <Grid item xs={12}>
                    <TextField
                      required
                      id="secondaryEmail"
                      name="secondaryEmail"
                      label="Secondary Email"
                      variant="standard"
                      fullWidth
                      {...register("secondaryEmail")}
                      error={errors.secondaryEmail ? true : false}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Grid
                      container
                      spacing={2}
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Controls.Button
                        type="submit"
                        text="Finish"
                        fullWidth
                        style={{ marginTop: "20px", fontSize: "15px" }}
                        variant="contained"
                        size="large"
                        color="primary"
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </form>
            </Grid>
          </Grid>
        </Paper>
      )}
    </>
  );
};
export default UserInfo;
